import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../../config/Config";

const initialState = {
    loading: false,
    error: null,
    data: null,
    generatePayrollData: [],
    list: null
};

export const fetchPayrollRules = createAsyncThunk(
    "fetchPayrollRules",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(
                `/crm/payroll/payroll-salary-rules-list?page=${body.page}&search=${body.search}`
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

export const generatePayroll = createAsyncThunk(
    "generatePayroll",
    async (data, { rejectWithValue }) => {
        try {
            const response = await instance.post(
                "/crm/payroll/generate-payroll",
                data
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

// export const generatePayrollList = createAsyncThunk(
//     "generatePayrollList",
//     async (body, { rejectWithValue }) => {
//         try {

//             const response = await instance.get("/crm/payroll/get-salary",body);
//             return response.data;
//         } catch (error) {
//             return rejectWithValue(error?.response);
//         }
//     }
// );


export const generatePayrollList = createAsyncThunk(
    "generatePayrollList",
    async (body, { rejectWithValue }) => {
        try {

            const response = await instance.get("/crm/payroll/get-salary", {
                params: body
            });

            return response.data;

        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const generatePayrollUpload = createAsyncThunk(
    "generatePayrollUpload",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await instance.post(
                "/crm/payroll/generate-payroll-and-upload",
                formData
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);

        }
    }
);

export const sendEmailPayslip = createAsyncThunk(
    "sendEmailPayslip",
    async (formData, { rejectWithValue }) => {
        try {

            const response = await instance.post(
                "/crm/payroll/send-mail-salary-slip",
                formData
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);

        }
    }
);

export const fetchSalaryStructure = createAsyncThunk(
    "fetchSalaryStructure",
    async (_, { rejectWithValue }) => {
        try {
            const response = await instance.get(
                "/crm/payroll/fetch-salary-structure"
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

const GeneratePayrollSlice = createSlice({
    name: "GeneratePayrollSlice",
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchPayrollRules.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchPayrollRules.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchPayrollRules.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.data;
            });

        builder
            .addCase(generatePayroll.pending, (state) => {
                state.loading = true;
            })
            .addCase(generatePayroll.fulfilled, (state, action) => {

                state.loading = false;
                state.generatePayrollData = action.payload;
            })
            .addCase(generatePayroll.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.data;
            });

        builder
            .addCase(generatePayrollList.pending, (state) => {
                state.loading = true;
            })
            .addCase(generatePayrollList.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload;
            })
            .addCase(generatePayrollList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.data;
            });


        builder
            .addCase(sendEmailPayslip.pending, (state) => {
                state.loading = true;
            })
            .addCase(sendEmailPayslip.fulfilled, (state, action) => {

                state.loading = false;
                state.generatePayrollData = action.payload;
            })
            .addCase(sendEmailPayslip.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.data;
            });
        builder
            .addCase(generatePayrollUpload.pending, (state) => {
                state.loading = true;
            })
            .addCase(generatePayrollUpload.fulfilled, (state, action) => {

                state.loading = false;
                state.generatePayrollData = action.payload;
            })
            .addCase(generatePayrollUpload.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.data;
            });

        builder
            .addCase(fetchSalaryStructure.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchSalaryStructure.fulfilled, (state, action) => {
                state.loading = false;
                state.salaryStructures = action.payload?.data;
            })
            .addCase(fetchSalaryStructure.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.data;
            });
    },
});

export default GeneratePayrollSlice.reducer;